import { GuestGroupDropdownOption } from '@bridebook/web/components/inbox/guests/create-message-flow/step-2-recipients/recipients';

export const mapGroupValueToAnalyticsLabel = (groupValue: GuestGroupDropdownOption['value']) => {
  switch (groupValue) {
    case 'events':
      return 'Events';
    case 'guestGroups':
      return 'Guest groups';
    case 'rsvpStatus':
      return 'RSVP Status';
    case 'email':
      return 'Email - missing';
  }
};
